import { AUTH_API, handleApiError } from '../../utils/axios';

export const getVisitTasks = async (vin, visitId) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/vehicles/${vin}/visits/${visitId}/tasks`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createVisitTask = async (vin, visitId, task) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/vehicles/${vin}/visits/${visitId}/tasks`, task);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateVisitTask = async (vin, visitId, taskId, task) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/vehicles/${vin}/visits/${visitId}/tasks/${taskId}`, task);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteVisitTask = async (vin, visitId, taskId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/vehicles/${vin}/visits/${visitId}/tasks/${taskId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
